import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const START_PROCESS_TRANSACTION_MODAL_OPEN = 'START_PROCESS_TRANSACTION_MODAL_OPEN'
export const START_PROCESS_TRANSACTION_MODAL_CLOSE = 'START_PROCESS_TRANSACTION_MODAL_CLOSE'
export const START_PROCESS_TRANSACTION_MODAL_CANCEL = 'START_PROCESS_TRANSACTION_MODAL_CANCEL'
export const START_PROCESS_TRANSACTION_MODAL_SUBMITTED = 'START_PROCESS_TRANSACTION_MODAL_SUBMITTED'
export const START_PROCESS_TRANSACTION_MODAL_VALIDATE = 'START_PROCESS_TRANSACTION_MODAL_VALIDATE'
export const START_PROCESS_TRANSACTION_MODAL_RESET = 'START_PROCESS_TRANSACTION_MODAL_RESET'

const open = (content) => ({
  type: START_PROCESS_TRANSACTION_MODAL_OPEN,
  content,
})

const close = () => ({
  type: START_PROCESS_TRANSACTION_MODAL_CLOSE,
})

const cancel = () => ({
  type: START_PROCESS_TRANSACTION_MODAL_CANCEL,
  content: null,
})

const submit = (newData) => ({
  type: START_PROCESS_TRANSACTION_MODAL_SUBMITTED,
  newData,
})

const validate = (isValidated) => ({
  type: START_PROCESS_TRANSACTION_MODAL_VALIDATE,
  isValidated,
})

const reset = () => ({
  type: START_PROCESS_TRANSACTION_MODAL_RESET,
})

export const openProcessTransactionStartModalDialog = (content) => (dispatch) => {
  dispatch(open(content))
}

export const closeProcessTransactionStartModalDialog = () => (dispatch) => {
  dispatch(close())
}

export const cancelProcessTransactionStartModalDialog = () => (dispatch) => {
  dispatch(cancel())
}

export const submitProcessTransactionStartModalDialog = (data) => (dispatch) => {
  dispatch(submit(data))
}

export const validateProcessTransactionStartModalDialog = (isValid) => (dispatch) => {
  dispatch(validate(isValid))
}

export const resetProcessTransactionStartModalDialog = () => (dispatch) => {
  dispatch(reset())
}

// API call to update identity
export const START_PROCESS_TRANSACTION_REQUEST = 'START_PROCESS_TRANSACTION_REQUEST'
export const START_PROCESS_TRANSACTION_SUCCESS = 'START_PROCESS_TRANSACTION_SUCCESS'
export const START_PROCESS_TRANSACTION_FAILURE = 'START_PROCESS_TRANSACTION_FAILURE'

export const startManualAml = (txId, body) => ({
  [CALL_API]: {
    endpoint: `/api/transactions/${txId}/start-phase-processing/`,
    types: [START_PROCESS_TRANSACTION_REQUEST, START_PROCESS_TRANSACTION_SUCCESS, START_PROCESS_TRANSACTION_FAILURE],
    method: 'POST',
    body,
    tokenType: API_JWT_TOKEN_NAME,
  },
})
